import { getProjects } from "../../../services/api-server/projects";
import { getUsers } from "../../../services/api-server/user";
import { LookupConfig } from "../../find_unique_ids_in_list";
import { fetchAcrossOperatorsByIds } from "./_lookupConfigHelpers";

export const createMyReportsLookupConfig = (
	operators: string[]
): LookupConfig[] => {
	const projectFetch = (ids: any[]) =>
		fetchAcrossOperatorsByIds(
			operators,
			ids,
			(op, ids) =>
				getProjects(op, { _id: { $in: ids } }) as Promise<any[] | null>
		);
	return [
		{
			fetch: projectFetch,
			sourceKey: "project",
			targetKey: "_id",
			outputKey: "project_name",
			transform: (item: any) => item?.project_name,
		},
		{
			fetch: (emails: string[]) => getUsers(emails) as Promise<any[] | null>,
			sourceKey: "assigned_to",
			targetKey: "email",
			outputKey: "assigned_to_details",
			transform: (item: any) => ({
				email: item?.email,
				name: item?.name,
			}),
		},
	];
};
